// extracted by mini-css-extract-plugin
export default {"col_1230":"index_col_1230_m8bqJ"};